<template>
    <div
        class="exportPerson flex-row-box flex-justify-center flex-cont-center"
        @click="closeBox"
    >
        <div class="exportPersonBox">
            <div class="flex-row-box headerList">
                <div class="exportTitle" />
                <div class="flex-1 text-center">人员批量导入</div>
                <div class="text-center exportTitle" @click="closeOver">
                    <i class="el-icon-error" />
                </div>
            </div>
            <div class="contentBox">
                <el-form label-width="150px">
                    <el-form-item label="模板" :required="true">
                        <el-button type="primary" @click="exportTableE"
                            >下载模板</el-button
                        >
                    </el-form-item>
                    <div class="flex-row-box">
                        <el-form-item label="公司名称" :required="true">
                            <el-select v-model="companyId" filterable clearable>
                                <el-option
                                    v-for="v in company"
                                    :key="v.id"
                                    :value="v.id"
                                    :label="v.companyName"
                                />
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="flex-row-box">
                        <el-form-item label="是否参加学习" :required="true">
                            <el-select
                                v-model="isTheCurrentRelated"
                                @change="isClickRelated"
                            >
                                <el-option
                                    v-for="v in isRelatedNum"
                                    :key="v.id"
                                    :value="v.id"
                                    :label="v.name"
                                />
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="flex-row-box">
                        <el-form-item label="是否参加状态测评" :required="true">
                            <el-select v-model="isEnabled">
                                <el-option
                                    v-for="(v, i) in options"
                                    :key="i"
                                    :value="v.value"
                                    :label="v.label"
                                />
                            </el-select>
                        </el-form-item>
                    </div>
                    <!-- <div class="flex-row-box" v-if="isTheCurrentRelated != 1"> -->
                    <!-- <div class="flex-row-box">
                        <el-form-item label="当月是否生效" :required="true">
                            <el-select v-model="isTheCurrentMonthRelated">
                                <el-option
                                    v-for="v in isRelatedNum"
                                    :key="v.id"
                                    :value="v.id"
                                    :label="v.name"
                                />
                            </el-select>
                        </el-form-item>
                    </div> -->
                    <el-form-item label="上传文件" :required="true">
                        <el-button type="primary" @click="inputFlieClick"
                            >点击上传</el-button
                        >
                        <input
                            ref="inputer"
                            type="file"
                            id="fileId"
                            class="inputFlieNone"
                            @change="getFile"
                        />
                        <div v-if="inputFlieText" class="inputText">
                            {{ inputFlieText }}
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div class="flex-row-box flex-justify-center">
                <el-button
                    type="primary"
                    style="width: 130px"
                    @click="postAddPerson"
                    >提交</el-button
                >
                <div style="width: 100px" />
                <el-button type="info" style="width: 130px" @click="closeOver"
                    >取消</el-button
                >
            </div>
        </div>
    </div>
</template>

<script>
import { company, dropUserPosition, downloadTemplate, uesrBatch } from "@/api";
import { bytesToFile } from "@/utils/handleByte";
export default {
    name: "BatchExport",
    props: {
        row: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            show: true,
            options: [
                {
                    value: "0",
                    label: "是",
                },
                {
                    value: "1",
                    label: "否",
                },
            ],
            isEnabled: "0",
            fileList: [],
            company: [],
            companyId: this.$admin ? null : this.$companyId,
            position: [],
            positionId: "",
            personUrl: "",
            inputFlieText: "",
            inputFlieUrl: "",
            isRelatedNum: [
                {
                    name: "是",
                    id: 0,
                },
                {
                    name: "否",
                    id: 1,
                },
            ],
            isTheCurrentMonthRelated: 0,
            isTheCurrentRelated: 1,
        };
    },
    created() {
        // //console.log(this.row.name)
        this.getCompany();
    },
    methods: {
        isClickRelated() {
            let that_ = this;
            // if (this.isTheCurrentRelated == 1) {
            //     this.isTheCurrentMonthRelated = 1;
            // } else {
            //     this.isTheCurrentMonthRelated = 0;
            // }
        },
        getCompany() {
            this.$axiosReq(
                company,
                null,
                {
                    pageSize: 10000,
                },
                "get"
            ).then((res) => {
                this.company = res.data.content;
            });
        },
        closeBox(e) {
            if (
                e.target.className ===
                "exportPerson flex-row-box flex-justify-center flex-cont-center"
            ) {
                this.show = false;
                this.$emit("refresh");
            }
        },
        closeOver() {
            this.show = false;
            this.$emit("refresh");
        },
        getPosition(v) {
            this.$axiosReq(
                dropUserPosition,
                null,
                {
                    companyId: this.companyId,
                },
                "get"
            ).then((res) => {
                this.position = res.data;
            });
        },
        exportTableE() {
            this.loading = true;
            this.$axiosReq(
                "/oauth/server/escort/web/user/excel",
                null,
                null,
                "get"
            )
                .then((res) => {
                    bytesToFile(res.data.bytes, res.data.fileName);
                })
                .finally((e) => {
                    this.loading = false;
                });
        },
        inputFlieClick() {
            var input = this.$refs.inputer;
            input.click();
        },
        getFile() {
            var that_ = this;
            const inputFile = that_.$refs.inputer.files[0];
            that_.inputFlieText = inputFile.name;
        },
        postAddPerson() {
            var that_ = this;
            if (!this.companyId) {
                that_.$message.error("请选择公司名称");
                return false;
            }
            if (!this.isEnabled) {
                that_.$message.error("请选择是否参加状态测评");
                return false;
            }
            var inputFile = that_.$refs.inputer.files[0];
            if (!inputFile) {
                that_.inputFlieText = "";
                that_.$message.error("请上传正确的文件");
                return false;
            }
            that_.inputFlieUrl = new FormData();
            that_.inputFlieUrl.append("file", inputFile);
            this.$axiosReq(
                "/oauth/server/escort/web/user/excel?companyId=" +
                    this.companyId +
                    "&isTheCurrentMonthRelate=" +
                    this.isEnabled +
                    "&isRelatedCourses=" +
                    this.isTheCurrentRelated,
                that_.inputFlieUrl,
                null,
                "post"
            ).then((res) => {
                that_.$message.success(res.msg);
                that_.closeOver();
            });
            setTimeout(function () {
                var nowFile = that_.$refs.inputer;
                nowFile.value = "";
                nowFile.outerHTML = nowFile.outerHTML;
                that_.inputFlieText = "";
            }, 1000);
        },
    },
};
</script>

<style scoped>
.exportPerson {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 99;
}

.exportPersonBox {
    width: 40%;
    height: 70%;
    background-color: #ffffff;
}

.headerList {
    padding: 20px 0;
    border-bottom: 1px solid #c3c3c3;
    color: #5c8bff;
    font-weight: bold;
    font-size: 20px;
}

.exportTitle {
    width: 50px;
    cursor: pointer;
}

.contentBox {
    padding: 20px;
    box-sizing: border-box;
    font-weight: bold;
}

.inputFlie {
    width: 100px;
    height: 40px;
    font-size: 14px;
    color: #ffffff;
    background-color: #5a8cff;
    border-radius: 5px;
    font-weight: 400;
}

.inputFlieNone {
    width: 150px;
    height: 40px;
    display: none;
}

.inputText {
    font-size: 16px;
}
</style>
